import { useAuth } from '../contexts/AuthContext';

/**
 * User bị giới hạn theo outlet (role outlet_manager, không phải org_admin / platform) — CHỈ để ẩn/hiện menu, nút gọn gàng. Quyền thật do SERVER chặn
 * (bo-gateway: allowlist deny-by-default, error_code 'insufficient_scope'). Task 070-E.
 */
export function useIsOutletScoped(): boolean {
  const { user } = useAuth();
  if (!user || user.user_type === 'platform_user') return false;
  const roles = (user.roles || user.organization_roles || []) as string[];
  return roles.includes('outlet_manager') && !roles.includes('org_admin');
}
